import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import { DialogContent, DialogActions, Button, CircularProgress } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import styled from "styled-components";
import { PrimaryButton, ButtonText, ButtonSizeOptions, DEAL_STATUSES } from "@loanbossinc/component-library";
import { GridListSelection } from "component-lib/GridListSelection";
import { DynamicStepper } from "component-lib/DynamicStepper";
import { ToastError } from "../components/Global/Toasts/Toasty";

const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;
const StyledButtonText = styled(ButtonText)`&&{
  height: 36px;
  margin-right: 26px;
}`
const allowedStatuses = [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.ADDING_SUPPLEMENTAL, DEAL_STATUSES.MODIFYING];

export class DealPdfSummaryModal extends React.Component {
  state = {
    deals: []
    , activeStep: 0
    , selectedDeals: []
    , hasInitialized: false
  }

  componentDidMount() {
    this.initDeals();
  }

  componentDidUpdate(prevProps) {
    // handles the issue that if they open the modal before the dealNames have returned
    // that it will load them into the modal when the query finishes
    if (this.props.deals !== prevProps.deals) this.initDeals();
  }

  initDeals = () => {
    const deals = [...this.props.deals].filter(deal => allowedStatuses.indexOf(deal.dealStatusId) >= 0);
    this.setState({ deals, hasInitialized: true });
  }

  // grid list items

  onToggleDeal = (item) => {
    if (!this.isItemSelected(item) && this.state.selectedDeals.length === this.props.maxDealsInPdfSummary) {
      ToastError(`You have selected the maximum of ${this.props.maxDealsInPdfSummary} deals`);
    } else if (this.isItemSelected(item)) {
      this.removeDeal(item)
    } else {
      this.addDeal(item)
    }
  };

  isItemSelected = ({ id }) => this.state.selectedDeals.findIndex(item => item.id === id) >= 0;

  addDeal = (deal) => {
    const selectedDeals = [...this.state.selectedDeals];
    selectedDeals.push(deal);
    this.setState({ selectedDeals });
  }

  removeDeal = (deal) => {
    const selectedDeals = [...this.state.selectedDeals];
    const index = selectedDeals.findIndex(item => item.id === deal.id);
    selectedDeals.splice(index, 1);

    this.setState({ selectedDeals });
  }

  getGridList = () => (
    <GridListSelection
      style={{ maxHeight: 500, margin: 0 }}
      items={this.state.deals}
      display={(item) => item.name}
      cellHeight={40}
      cols={3}
      spacing={4}
      isSelected={(item) => this.isItemSelected(item)}
      onToggle={(item) => this.onToggleDeal(item)}
    />
  )

  // download/spinner

  getDownLoadStep = () => {
    if (this.props.isLoading) {
      return (
        <div style={{ width: "100%", textAlign: "center", marginTop: "30px", fontSize: "16pt" }}>
          <CircularProgress size={120} thickness={1} />
        </div>
      )
    }

    return (
      <div style={{ width: "100%", textAlign: "center", marginTop: "30px", fontSize: "16pt" }}>
        <CheckIcon style={{ width: '5em', height: '5em' }} color='primary' />
        <Description>All Done! Your Deal Summary export has begun.</Description>
      </div>
    )
  }

  // stepper

  closeModal = () => this.props.onClose();

  steps = [
    { id: 1, label: 'Select Deals' }
    , { id: 2, label: 'Download' }
  ];

  setStep = (activeStep) => this.setState({ activeStep });

  getStepContent = () => {
    const { activeStep } = this.state;
    switch (activeStep) {
      case 0:
        return this.getGridList();

      case 1:
        return this.getDownLoadStep();
    }
  }

  onGeneratePdf = () => {
    this.setStep(1);
    const dealIds = this.state.selectedDeals.map(x => x.id);
    this.props.onDownload({ dealIds });
  }

  selectAllDeals = () => {
    const deals = [...this.props.deals].filter(deal => allowedStatuses.indexOf(deal.dealStatusId) >= 0);
    this.setState({ deals, selectedDeals: deals, hasInitialized: true });
  }

  render() {
    const { activeStep } = this.state;
    const { isOpen, maxDealsInPdfSummary } = this.props;

    return (
      <Fragment>
        <Dialog
          open={isOpen}
          onClose={this.closeModal}
          maxWidth="md"
          fullWidth

          id="dealExportDialog">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Download Loan Summaries</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.closeModal} id="exitCustomizePreferences">
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>

          <DialogContent>
            <Description>Select up to {maxDealsInPdfSummary} deals to summarize their loans into a single PDF</Description>

            <DynamicStepper
              activeStep={activeStep}
              steps={this.steps}
            />

            {this.getStepContent()}
          </DialogContent>

          <DialogActions>
            {activeStep === 0 && (
              <div style={{ justifyContent: 'space-between', display: 'flex', flex: '1 0 auto' }}>
                <div style={{ padding: '8px 16px', width: '150px' }}>
                  {this.state.selectedDeals.length} / {maxDealsInPdfSummary} Selected
                </div>

                <Grid container direction="row" justify="flex-end">
                  {(this.state.deals.length <= maxDealsInPdfSummary) &&
                    <StyledButtonText
                      label="Select All Deals"
                      size={ButtonSizeOptions.smFluid}
                      onClick={this.selectAllDeals}
                    />
                  }
                  <PrimaryButton
                    label="Download PDF"
                    size={ButtonSizeOptions.smFluid}
                    onClick={this.onGeneratePdf}
                  />
                </Grid>

              </div>
            )}
            {activeStep === 1 && <Button onClick={this.closeModal} color="primary">DONE</Button>}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}
